import { render, staticRenderFns } from "./objcom.vue?vue&type=template&id=28478ba8&scoped=true&"
import script from "./objcom.vue?vue&type=script&lang=js&"
export * from "./objcom.vue?vue&type=script&lang=js&"
import style0 from "./objcom.vue?vue&type=style&index=0&id=28478ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28478ba8",
  null
  
)

export default component.exports